import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getProducts, getFlashMessage, getSubscription } from '../store/selectors';
import { Title } from '../components/Title';
import { ContentWrapper, DefaultWrapper, rem } from '../lib/global-styles';
import ProductsList from '../components/Products/ProductsList';
import Checkout from '../components/Checkout';
import { postMessageSender } from '../lib/postMessager';
import flashMessageTypes from '../constants/flashMessageTypes';
import { NavButtons } from '../components/NavButtons';
import { Button } from '../components/Button';
import subscriptionStatus from '../constants/subscriptionStatus';
import tv from '../images/img-tv.svg';
import { doShowModal, doHideModal, doRequestUpdateProduct } from '../store/actions';
import { ActionButtons } from './ProductEdit';
import Modal from '../components/Modal/Modal';
import FlashMessage from '../components/FlashMessage';

const ComboGroupDescription = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(30)};

  img {
    margin-right: ${rem(24)};
    width: ${rem(96)};
    border: 2px solid #cecece;
    border-radius: ${rem(48)};
  }

  p {
    line-height: ${rem(20)};
  }
`;

class OptionalRecharge extends Component {
  constructor(props) {
    super(props);
    const that = this;
    this.state = {
      checkoutOpen: false,
      selectedProduct: null,
      selectedColor: null,
      comboGroup: that.setComboGroup(),
      productsByComboGroup: that.setProductsByComboGroup(),
      isSubscriptionActive: false,
      modalContent: {
        image: tv,
        title: '',
        content: '',
      },
    };
  }

  componentDidMount() {
    const { status } = this.props.subscription;
    const isSubscriptionActive = status === subscriptionStatus.ATIVA;

    this.setState({ isSubscriptionActive });

    postMessageSender({
      scrollTop: true,
    });
  }

  setComboGroup = () => {
    const { products } = this.props;
    const { combo } = this.props.match.params;

    return products.find(
      product => product.isCombo && product.combo.name.toLowerCase() === combo.toLowerCase(),
    );
  };

  setProductsByComboGroup = () => {
    const { products } = this.props;
    const { combo } = this.props.match.params;

    return products.filter(
      product => product.isCombo && product.combo.name.toLowerCase().includes(combo.toLowerCase()),
    );
  };

  onProductClick = (e, product, color) => {
    e.preventDefault();

    const { isSubscriptionActive } = this.state;

    if (isSubscriptionActive) {
      const message = `Tem certeza que deseja mudar para o <span>Pacote ${
        product.groupName
      }</span>?`;
      const { modalContent } = this.state;

      this.setState(
        {
          selectedProduct: product,
          modalContent: { ...modalContent, content: message },
        },
        () => {
          this.props.onShowModal('product-edit-confirmation');
        },
      );

      postMessageSender({
        action: 'productSelected',
        product: {
          id: product.id,
          name: product.groupName,
        },
        scrollTop: true,
      });
    } else {
      this.setState({
        selectedProduct: product,
        selectedColor: color,
        checkoutOpen: true,
      });

      postMessageSender({
        action: 'productSelected',
        product: {
          id: product.id,
          name: product.groupName,
        },
        scrollTop: true,
      });
    }
  };

  onCloseCheckout = (e, isFromCloseButton = false) => {
    e.preventDefault();
    const { flashMessage, onFetchSubscription, onSetFlashMessage } = this.props;

    if (e.target === e.currentTarget || isFromCloseButton) {
      if (flashMessage.type === flashMessageTypes.success) {
        onSetFlashMessage(null);
        onFetchSubscription();
      }

      this.setState({
        checkoutOpen: false,
      });
    }
  };

  onConfirmClick = () => {
    const { onRequestUpdateProduct } = this.props;
    const { selectedProduct } = this.state;

    onRequestUpdateProduct({ codigo: selectedProduct.id, price_list: selectedProduct.priceListId });
  };

  render() {
    const {
      comboGroup,
      productsByComboGroup,
      selectedProduct,
      checkoutOpen,
      selectedColor,
      isSubscriptionActive,
      modalContent,
    } = this.state;
    const { history, flashMessage, onHideModal } = this.props;

    return (
      <ContentWrapper paddingY={20} paddingX={20}>
        <DefaultWrapper>
          <ComboGroupDescription>
            <img alt={comboGroup.combo.name} src={comboGroup.combo.logo} />
            <p>{comboGroup.combo.description}</p>
          </ComboGroupDescription>
          <Title>Escolha seu combo com {comboGroup.combo.name}</Title>
          <ProductsList
            products={productsByComboGroup}
            selectedProduct={selectedProduct}
            onProductClick={this.onProductClick}
            edit={isSubscriptionActive}
          />

          <NavButtons>
            <Button onClick={history.goBack} dark noWidth>
              Voltar
            </Button>
          </NavButtons>
          {selectedProduct && checkoutOpen ? (
            <Checkout
              onCloseCheckout={this.onCloseCheckout}
              checkoutOpen={checkoutOpen}
              selectedProduct={selectedProduct}
              selectedColor={selectedColor}
            />
          ) : null}
          {modalContent.content ? (
            <Modal
              target="product-edit-confirmation"
              targetClass="product-edit-confirmation-modal"
              content={modalContent}
              width={465}
            >
              <hr />
              <ActionButtons>
                <button onClick={onHideModal}>Voltar</button>
                <button onClick={this.onConfirmClick}>Confirmar</button>
              </ActionButtons>
            </Modal>
          ) : null}

          {flashMessage.type ? (
            <Modal target="flash-message" targetClass="flash-message-modal">
              <FlashMessage modal />
            </Modal>
          ) : null}
        </DefaultWrapper>
      </ContentWrapper>
    );
  }
}

OptionalRecharge.propTypes = {
  products: PropTypes.array,
  flashMessage: PropTypes.object,
  subscription: PropTypes.object,
};

const mapStateToProps = state => ({
  products: getProducts(state),
  subscription: getSubscription(state),
  flashMessage: getFlashMessage(state),
});

const mapDispatchToProps = dispatch => ({
  onRequestUpdateProduct: product => dispatch(doRequestUpdateProduct(product)),
  onShowModal: target => dispatch(doShowModal(target)),
  onHideModal: () => dispatch(doHideModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OptionalRecharge);
